// libraries
import { useContext, useState, useEffect } from "react";
import { useParams, useHistory } from "react-router-dom";
import RecipesContext from "../../context/recipes";
import firebase from "../../firebase/firebase";
import { useToasts } from "react-toast-notifications";

// helpers
import { getSingleRecipe } from "../../utils/helpers";

// icons
import { IoLogoInstagram, IoLogoYoutube } from "react-icons/io";
import { IoArrowBackCircle } from "react-icons/io5";
import { GoPrimitiveDot } from "react-icons/go";
import { FaTrash } from "react-icons/fa";
import { GoCheck } from "react-icons/go";

// components
import Loading from "../../components/Loading";

const recipesDocument = firebase.firestore().collection("recipes");

const AdminRecipeDetails = () => {
  // use params
  const { id } = useParams();

  // use state
  const [comploading, setCompLoading] = useState(false);
  const [switchOn, setSwitchOn] = useState(false);

  // use history
  const history = useHistory();

  // use context
  const { allRecipes, loading } = useContext(RecipesContext);
  var singleRecipe = getSingleRecipe(allRecipes, id);

  // use toast
  const { addToast } = useToasts();

  const { uuid } = singleRecipe;

  useEffect(() => {
    recipesDocument
      .doc(uuid)
      .get()
      .then((snap) => {
        setSwitchOn(snap.data().recommended);
      });
  }, [uuid]);

  const handleSwitch = (e) => {
    if (e.stopPropagation) e.stopPropagation();
    setCompLoading(true);
    setSwitchOn(!switchOn);
    recipesDocument
      .doc(singleRecipe.uuid)
      .update({
        recommended: switchOn ? false : true,
      })
      .then(() => {
        addToast("Recipe recommended status changed!", {
          appearance: "success",
        });
        setCompLoading(false);
      })
      .catch(() => {
        setCompLoading(false);
        addToast("An error has occurred! Please try again", {
          appearance: "error",
        });
      });
  };

  // handle approve click
  const approveItem = (e, id) => {
    if (e.stopPropagation) e.stopPropagation();
    setCompLoading(true);
    recipesDocument
      .doc(id)
      .update({
        status: "approved",
      })
      .then(() => {
        addToast("Recipe status changed successfully!", {
          appearance: "success",
        });
        setCompLoading(false);
      })
      .catch(() => {
        setCompLoading(false);
        addToast("An error has occurred! Please try again", {
          appearance: "error",
        });
      });
  };
  // handle reject click
  const rejectItem = (e, id) => {
    if (e.stopPropagation) e.stopPropagation();
    setCompLoading(true);
    recipesDocument
      .doc(id)
      .update({
        status: "rejected",
      })
      .then(() => {
        addToast("Recipe status changed successfully!", {
          appearance: "success",
        });
        setCompLoading(false);
      })
      .catch((e) => {
        setCompLoading(false);
        addToast("An error has occurred! Please try again", {
          appearance: "error",
        });
      });
  };

  if (loading && allRecipes.length === 0) {
    return (
      <div className='loading-wrapper'>
        <Loading />
      </div>
    );
  } else {
    const {
      recipe,
      cooktime,
      category,
      image,
      ingredients,
      ingredientsNumber,
      instagram,
      instructions,
      meal,
      youtube,
      status,
      uuid,
    } = singleRecipe;
    return (
      <div style={{ height: "calc(100vh - 65px)", overflowY: "scroll" }}>
        {comploading && <Loading fixed={true} />}
        <section className='ftco-section'>
          <div className='container'>
            <div className='row'>
              <div className='col-lg-6 mb-5'>
                <IoArrowBackCircle
                  size={40}
                  className='back-nav'
                  onClick={() => history.goBack()}
                />
                <img style={{ width: "100%" }} src={image} alt={recipe} />
              </div>
              <div className='col-lg-6 product-details pl-md-5'>
                <h3
                  style={{
                    color: "#d63230",
                    fontSize: "2rem",
                    fontWeight: "bold",
                  }}
                >
                  {recipe}
                </h3>
                <div className='rating d-flex'>
                  <p className='text-left mr-4'>
                    Cook Time
                    <span className='mr-2 d-inline text-primary'>
                      {" "}
                      {cooktime}
                    </span>
                  </p>
                  <p className='text-left mr-4'>
                    <span
                      className='mr-2 text-capitalize'
                      style={{ color: "#000" }}
                    >
                      <span style={{ color: "#bbb" }}> {category}</span>
                    </span>
                  </p>
                  <p className='text-left'>
                    <span className='mr-2' style={{ color: "#000" }}>
                      For{" "}
                      <span
                        style={{ color: "#bbb", textTransform: "capitalize" }}
                      >
                        {meal}
                      </span>
                    </span>
                  </p>
                </div>
                <div
                  className='d-flex align-items-center'
                  style={{ flex: "1" }}
                >
                  <label className='m-0 mr-2'>Recommended</label>
                  <div
                    onClick={(e) => handleSwitch(e)}
                    className='ToggleSwitch'
                  >
                    <div className={switchOn ? "knob switch-active" : "knob"} />
                  </div>
                </div>
                <div className='my-3'>
                  Actions
                  {status === "approved" ? (
                    <div
                      className='trash-wrapper'
                      onClick={(e) => rejectItem(e, uuid)}
                    >
                      <FaTrash className='trash' />
                    </div>
                  ) : status === "pending" ? (
                    <div className='row align-items-center'>
                      <div
                        className='trash-wrapper'
                        onClick={(e) => approveItem(e, uuid)}
                      >
                        <GoCheck className='check' size={20} />
                      </div>
                      <div
                        className='trash-wrapper'
                        onClick={(e) => rejectItem(e, uuid)}
                      >
                        <FaTrash className='trash' />
                      </div>
                    </div>
                  ) : (
                    <div
                      className='trash-wrapper'
                      onClick={(e) => approveItem(e, uuid)}
                    >
                      <GoCheck className='check' size={20} />
                    </div>
                  )}
                </div>
                <p className='price'>
                  <span
                    style={{
                      textTransform: "capitalize",
                      fontSize: "1.6rem",
                      fontWeight: "600",
                    }}
                  >
                    {ingredientsNumber} Ingredients
                  </span>
                </p>
                <p style={{ marginTop: "-15px", color: "#000" }}>
                  {ingredients.map((ing, i) => (
                    <span
                      key={i}
                      style={{
                        color: "#666",
                        textTransform: "capitalize",
                        display: "block",
                      }}
                    >
                      <GoPrimitiveDot size={12} color='#d63230' /> {ing.value}
                    </span>
                  ))}
                </p>
                <div className='row mt-4'>
                  <div className='col-md-6'>
                    <div className='form-group d-flex'>
                      <div className='select-wrap'>
                        <div className='icon'>
                          <span className='ion-ios-arrow-down'></span>
                        </div>
                        {/* <select name='' id='' className='form-control'>
                      <option value=''>Small</option>
                      <option value=''>Medium</option>
                      <option value=''>Large</option>
                      <option value=''>Extra Large</option>
                    </select> */}
                        {youtube !== "" && (
                          <a
                            href={youtube}
                            target='_blank'
                            rel='noopener noreferrer'
                            className='mx-3'
                          >
                            <IoLogoYoutube size={40} />
                          </a>
                        )}
                        {instagram !== "" && (
                          <a
                            href={instagram}
                            target='_blank'
                            rel='noopener noreferrer'
                            className='mx-3'
                          >
                            <IoLogoInstagram size={40} />
                          </a>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className='my-5'>
              <h3>Cooking Instructions</h3>
              <div dangerouslySetInnerHTML={{ __html: instructions }} />
            </div>
          </div>
        </section>
      </div>
    );
  }
};

export default AdminRecipeDetails;
